import { createContext, Dispatch, FC, ReactNode, useState } from "react";
import { IBeehiveAlert } from "../interfaces/beehiveAlerts";

interface INotificationsContext {
    currentNotification: IBeehiveAlert | undefined;
    setCurrentNotification: Dispatch<React.SetStateAction<IBeehiveAlert | undefined>>;
    notifications: IBeehiveAlert[];
    setNotifications: Dispatch<React.SetStateAction<IBeehiveAlert[]>>;
    headerNotifications: IBeehiveAlert[];
    setHeaderNotifications: Dispatch<React.SetStateAction<IBeehiveAlert[]>>;
}

export const NotificationsContext = createContext<INotificationsContext | undefined>(
    undefined
);

export const NotificationsProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<IBeehiveAlert[]>([]);
    const [headerNotifications, setHeaderNotifications] = useState<IBeehiveAlert[]>([]);
    const [currentNotification, setCurrentNotification] = useState<IBeehiveAlert | undefined>(undefined);

    const value = {
        currentNotification,
        setCurrentNotification,
        notifications,
        setNotifications,
        headerNotifications,
        setHeaderNotifications
    };

    return (
        <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
    );
};